/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/** Platform tenant for resolving LIVE default VibeFlow template graphs */
export const BERLIN_PLATFORM_TENANT_ID = '0';

/** GET /graphs query — Agent Generator template (emits `{ nodes, edges }` from natural-language input) */
export const BERLIN_AGENT_GENERATOR_GRAPHS_QUERY = {
  template: true,
  type: 'vibecode_graphs',
  option: 'agent_generator'
};

/** GET /graphs query — Prompt Generator template (streamed prompt text per agent description) */
export const BERLIN_AGENT_PROMPT_GRAPHS_QUERY = {
  template: true,
  type: 'prompt_graphs',
  option: 'prompt_generator'
};

/** VibeFlow Send lifecycle for progressive right-panel checklist */
export const BERLIN_PIPELINE_PHASE = {
  IDLE: 'idle',
  RUNNING: 'running',
  DONE: 'done',
  ERROR: 'error'
};

/** Structured pipeline row status */
export const BERLIN_STEP_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  DONE: 'done',
  ERROR: 'error'
};

/** Structured pipeline row kind (checklist step type) */
export const BERLIN_STEP_KIND = {
  REQUEST: 'request',
  LAYOUT: 'layout',
  AGENT: 'agent',
  READY: 'ready'
};

/** advanceAgentUi phase when enriching agent prompts */
export const BERLIN_AGENT_UI_PHASE = {
  BEFORE: 'before',
  AFTER: 'after'
};
